import React from 'react'
import { useTranslation } from 'react-i18next'
import { Icon, IconType, InputRadioGroup, ListSectionHeader } from '@lmc/ui-kit'
import { colors } from '@lmc/common/constants'
import styled from 'styled-components'

type SignNowLaterSectionProps = {
  onChange: any
  translate: (key: string, variable?: any) => string
  value: 'now' | 'later'
}

const InputRadioGroupStyled = styled(InputRadioGroup)`
  .ant-radio-group {
    flex-direction: row;
  }
`

const SignNowLaterSection = ({
  translate,
  onChange,
  value,
}: SignNowLaterSectionProps) => {
  const { t } = useTranslation()

  const signOptions = [
    { label: t('general.options.signOptions.now'), value: 'now' },
    {
      label: t('general.options.signOptions.later'),
      value: 'later',
    },
  ]

  return (
    <>
      <ListSectionHeader
        title={translate('signature')}
        icon={
          <div style={styles.squircle}>
            <Icon
              customIcon={IconType.Signature}
              style={styles.signatureIcon}
            />
          </div>
        }
        style={styles.listSectionHeader}
      />
      <div style={styles.container}>
        <div style={styles.title}>{translate('signNowLaterSection')}</div>
        <div style={styles.subTitle}>{translate('thisSignature')}</div>
        <div style={styles.box}>
          <InputRadioGroupStyled
            onChange={onChange}
            value={value}
            options={signOptions}
          />
        </div>
      </div>
    </>
  )
}

const styles = {
  container: {
    padding: 21,
    background: colors.white,
    borderRadius: 15,
  },
  box: {
    maxWidth: 450,
  },
  listSectionHeader: { marginTop: 50, marginBottom: 50 },
  signatureIcon: {
    fill: 'none',
  },
  squircle: {
    backgroundColor: colors.darkblue,
    color: colors.white,
    marginRight: 0,
    width: 40,
    height: 40,
    borderRadius: 4,
    fontWeight: 700,
    fontSize: 14,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginLeft: 10,
  },
  title: {
    fontWeight: 400,
    fontSize: 18,
  },
  subTitle: { fontWeight: 300, fontSize: 13, opacity: 0.6, marginBottom: 10 },
}

export default SignNowLaterSection
